import {
    LinkButton,
    Markdown,
    useAnalytics,
    useAnalyticsAttributes
} from "../../components";
import { UiNavBannerModel } from "../../models";
import { renderViewModel } from "../../render-view-model";
import { getColorInitial } from "../../utils";

import {
    Banner,
    BannerTitleContainer,
    BannerTitle,
    BannerDescription,
    BannerIcon
} from "./UiNavBanner.styles";

export type UiNavBannerProps = {
    readonly model: UiNavBannerModel;
    readonly tabIndex?: number;
};

const UiNavBanner = ({
    model: {
        type,
        content: { titleHeading, description, button, theme, uiIcon }
    },
    tabIndex
}: UiNavBannerProps): JSX.Element => {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();

    const themeInitial = getColorInitial(theme);

    return (
        <Banner themeInitial={themeInitial}>
            <div>
                <BannerTitleContainer themeInitial={themeInitial}>
                    {uiIcon && (
                        <BannerIcon themeInitial={themeInitial}>
                            {renderViewModel(uiIcon)}
                        </BannerIcon>
                    )}
                    <BannerTitle>
                        {themeInitial ? (
                            <p>{titleHeading}</p>
                        ) : (
                            <h3>{titleHeading}</h3>
                        )}
                    </BannerTitle>
                </BannerTitleContainer>
                <BannerDescription themeInitial={themeInitial}>
                    <Markdown>{description}</Markdown>
                </BannerDescription>
            </div>
            <div>
                {button && (
                    <LinkButton
                        url={button.content.url}
                        aria-label={button.content.ariaLabel}
                        onClick={() =>
                            sendTrackEvent("clickedUiNavBannerButton", {
                                eventContainer: type,
                                eventComponent: "button",
                                ...analyticsAttributes,
                                event: "clicked",
                                parentLabel: titleHeading,
                                label: button.content.text,
                                labelEnglish: button.content.entryTitle,
                                uuid: button.id,
                                href: button.content.url
                            })
                        }
                        data-uuid={button.id}
                        testId="ui-nav-banner-button"
                        appearance={
                            button.content.buttonTheme?.content.appearance
                        }
                        style={button.content.buttonTheme?.content.style}
                        tabIndex={tabIndex}
                    >
                        {button.content.text}
                    </LinkButton>
                )}
            </div>
        </Banner>
    );
};

export default UiNavBanner;
